import './Logout.scss';
import { Heading } from '@lmig/lmds-react-typography';
import { FloatingHeader } from '@lmig/lmds-react-floating-header';
import { getSuretyUrl, getStateAutoUrl, getMiddleMarketUrl, isBL, getPingLogoutLink, getWasLogoutLink, getPingLogoutIFrameURL, getBLDomain, getPLDomain } from 'Foundation/Configurations/GlobalConfiguration';
import { Link } from '@lmig/lmds-react-link';
import { Button } from '@lmig/lmds-react-button';
import LogoutIcon from 'Images/LogoutIcon';
import { HeaderAppName } from '@lmig/lmds-react-floating-header';
import UnauthenticatedPageFooter from 'Feature/Chrome/Footer/UnauthenticatedPageFooter';

const commercialAgentHostnamePattern = /(^|[-.])commercial-agent\.libertymutual\.com$/i;

export const isCommercialAgentReferrerUrl = (referrer?: string): boolean => {
  if (!referrer) {
    return false;
  }

  try {
    return commercialAgentHostnamePattern.test(new URL(referrer).hostname);
  } catch {
    return false;
  }
};

export default function Logout() {
  const isBLLogout = isBL();
  const suretyUrl = getSuretyUrl();
  const stateAutoUrl = getStateAutoUrl();
  const middleMarketUrl = getMiddleMarketUrl();
  const pingLogoutUrl = getPingLogoutLink();
  const wasLogoutUrl = getWasLogoutLink();
  const personalLinesUrl = getPLDomain();
  const commercialLinesUrl = getBLDomain();
  const pingLogoutIFrameURL = getPingLogoutIFrameURL();
  const startPageUrl = isBLLogout ? commercialLinesUrl : personalLinesUrl;
  const returnToText = isBLLogout ? 'Return to small commercial agent portal' : 'Return to personal lines agent portal';
  const appName = isBLLogout ? 'Small commercial' : 'Personal lines';
  const isCommercialAgentReferrer = isCommercialAgentReferrerUrl(document?.referrer);
  const shouldRenderIdpLogoutFrame = Boolean(pingLogoutIFrameURL) && (isBLLogout || !isCommercialAgentReferrer);

  return (
    <div className="logout-page">
      <FloatingHeader brand="liberty" isFullWidth={false} isFullBackground={false} >
        <HeaderAppName hideDivider={true}>
          {appName}
        </HeaderAppName>
      </FloatingHeader>
      <div className="logout-body">
        <div className="logout-top">
          <div className="logout-icon">
            <LogoutIcon />
          </div>
          <Heading type="h2-light">You have been logged out.</Heading>
        </div>
        <div className="logout-actions">
          <div className="logout-action-section">
            <Heading type="h4">{returnToText}</Heading>
            <div data-theme="evolved">
              <Button className="logout-action-button" href={startPageUrl} variant='secondary' size='medium'>Log in again</Button>
            </div>
          </div>
          <div className="logout-action-section">
            <Heading type="h4">Access other agent portals</Heading>
            <ul>
              {isBLLogout ?
                <li>
                  <Link variant="standalone" href={personalLinesUrl} target="_blank">
                    Personal lines
                  </Link>
                </li>
                :
                <li>
                  <Link variant="standalone" href={commercialLinesUrl} target="_blank">
                    Small commercial
                  </Link>
                </li>
              }

              <li>
                <Link variant="standalone" href={middleMarketUrl} target="_blank">
                  Middle Market / major accounts
                </Link>
              </li>
              <li>
                <Link variant="standalone" href={suretyUrl} target="_blank">
                  Surety
                </Link>
              </li>
              <li>
                <Link variant="standalone" href={stateAutoUrl} target="_blank">
                  State Auto
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {shouldRenderIdpLogoutFrame && (
        <iframe
          id="logout-placeholder-frame"
          src={pingLogoutIFrameURL}
          title="logout-placeholder"
          className="logout-placeholder-frame"
          hidden
          aria-hidden="true"
        />
      )}
      {isBLLogout &&
        <>
          {pingLogoutUrl && <iframe hidden src={pingLogoutUrl}></iframe>}
          {wasLogoutUrl && <iframe hidden src={wasLogoutUrl}></iframe>}
        </>
      }
      <UnauthenticatedPageFooter />
    </div>
  );
}
